/**
 * Recharge Wallet Product Remapper
 * Flutter: lib/data/models/recharge_wallet_product.dart
 */
import type { RechargeWalletProductDto } from '@/data/dtos/rechargeWalletProduct/rechargeWalletProductDto';
import type { JsonObject } from '@/data/types/json';
import type { RechargeWalletProductStorage } from '@/domain/entities/secureStorage/secureStorageEntities';

export class RechargeWalletProductRemapper {
  static toStorage(dto: RechargeWalletProductDto): RechargeWalletProductStorage {
    return {
      coins: dto.coins,
      name: dto.name,
      order: dto.order,
      price: dto.price,
      productId: dto.productId,
      currency: dto.currency,
      currencySymbol: dto.currencySymbol,
    };
  }

  static fromJson(data: JsonObject): RechargeWalletProductDto {
    return {
      coins: (data['coins'] as number | undefined) ?? 0,
      name: (data['name'] as string | undefined) ?? '',
      order: (data['order'] as number | undefined) ?? 0,
      price: (data['price'] as number | undefined) ?? 0,
      productId: (data['productId'] as string | undefined) ?? '',
      currency: (data['currency'] as string | undefined) ?? '',
      currencySymbol: (data['currencySymbol'] as string | undefined) ?? '',
    };
  }

  static fromJsonList(dataList: JsonObject[]): RechargeWalletProductDto[] {
    return dataList.map(RechargeWalletProductRemapper.fromJson);
  }
}
